import styled from 'styled-components';
import { crTheme } from '@comicrelief/component-library';

const Container = styled.div`
  position: relative;
  padding: 1.5rem 2.5rem 0.5rem;
  background-color: ${crTheme.color('black')};
  text-align: center;
  p, a {
    color: ${crTheme.color('white')};
  }
  a {
    text-decoration: underline;
  }
  a:hover {
    color: ${crTheme.color('white')};
    text-decoration: none;
  }
`;

const Cross = styled.button`
  /* size of button component / bordered area */
  --button-size: 1.6rem;
  width: var(--button-size);
  height: var(--button-size);

  /* size of svg cross background as ratio of button size */
  --svg-size: calc(var(--button-size) / 2);
  background: url("/assets/images/cross-white.svg") center center / contain no-repeat;
  background-size: var(--svg-size) var(--svg-size);

  /* positioning */
  position: absolute;
  top: 50%;
  right: 2%;
  transform: translateY(-50%);

  /* hover border */
  border: 1px solid transparent;
  &:hover {
    border: 1px solid ${crTheme.color('white')};
  }
`;

export { Container, Cross };
